import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core"
import { NgxPopperjsPlacements, NgxPopperjsTriggers } from "ngx-popperjs"
import { Subject } from "rxjs"
import Chart from 'chart.js/auto'
import { SidebarService } from "@app/core/services/sidebar.service"
import { User } from "@app/shared"

@Component({
  selector: 'app-dashboard-broker',
  templateUrl: './dashboard-broker.component.html',
  styleUrls: ['./dashboard-broker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class DashboardBrokerComponent implements OnInit, OnDestroy, AfterViewInit {
  public chartLines: any

  destroyed$ = new Subject<boolean>()
  interval: NodeJS.Timeout

  @Input()
  filters: { [key: string]: any }

  @Input()
  currentUser: User

  NgxPopperjsPlacements = NgxPopperjsPlacements
  NgxPopperjsTriggers = NgxPopperjsTriggers

  constructor(
    private sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
  ) { }

  @Input({ required: true })
  set data(val) {
    if (val) {
      this._data = val
      if (this.chartLines) {
        this.chartLines.destroy()
      }

      let line = []
      if (this._data?.conversions?.line) {
        line = this._data?.conversions?.line
      }

      this.createLinesChart(this._data?.conversions?.days, line)

    }
  }

  sortable = {
    sort: 'decr',
    field: 'averageConv'
  }

  @Input()
  set setLoading(val) {
    this.loading = val
  }

  _data

  @Output()
  onUpdate = new EventEmitter<any>()

  platformChart: Chart
  ratingChart: Chart

  loading = false

  ngAfterViewInit() {
    if (this.chartLines) {
      this.chartLines.resize('100%', '100%')
    }
  }

  ngOnInit() {
    this.interval = setInterval(() => {
      this.onUpdate.emit(this.filters)
    }, 18000 * 1000)
  }

  transformNumbers(numbers) {
    return numbers.map(number => {
      let integerPart = Math.floor(number / 100)
      let decimalPart = number % 100
      let transformedNumber = integerPart + decimalPart / 100
      return transformedNumber
    })
  }

  updateFilter(filter) {
    this.onUpdate.emit(filter)
  }

  onSort(field, sort) {

    this.sortable = {
      sort,
      field
    }
    if (field == 'name') {
      if (this.sortable.sort == 'incr') {
        this._data.users.sort((a, b) => a.name.localeCompare(b.name))
      } else {
        this._data.users.sort((a, b) => b.name.localeCompare(a.name))
      }
    } else {
      if (this.sortable.sort == 'incr') {
        this._data.users.sort((a, b) => a[field] - b[field])
      } else {
        this._data.users.sort((a, b) => b[field] - a[field])
      }
    }
  }

  createLinesChart(labels: string[], data: number[]) {
    this.chartLines = new Chart("line", {
      type: 'line',
      data: {
        labels,
        datasets: [{
          data,
          borderColor: '#D02323',
          backgroundColor: 'rgba(208, 35, 35, 0.2)',
          tension: 0.4,
          borderWidth: 2,
          pointBackgroundColor: '#D02323',
          pointBorderColor: '#D02323',
          pointRadius: 5,
          pointHoverRadius: 7,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              drawTicks: false,
              drawOnChartArea: false,
            }
          },
          y: {
            min: 0,
            max: 100,
            ticks: {
              stepSize: 25,
              callback: (value) => value + '%'
            },
            grid: {
              drawTicks: true,
              drawOnChartArea: true,
            }
          }
        },
        plugins: {
          legend: { display: false }
        }
      }
    })
  }

  get topUsers() {
    return this._data?.users?.slice(0, 3) || []
  }

  get otherUsers() {
    return this._data?.users?.slice(3) || []
  }

  ngOnDestroy() {
    this.destroyed$.next(true)
    this.destroyed$.complete()
  }
}
